import { site, asyncFetchGet, asyncFetchPost } from './global.js'


export const getUserById = (id) => asyncFetchGet('users', `/${id}/`)

export async function resetPassword(userId, oldPassword, newPassword) {
    return await asyncFetchPost(`users/${userId}/set_password`, {
        old_password: oldPassword,
        password: newPassword
    });
}

export async function updateUserProfile(userId, email, phone, avatar) {
    const formData = new FormData();
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("avatar", avatar);
    const res = await fetch(`${site}users/${userId}/`, {
        method: 'PATCH',
        body: formData,
        headers: {
            Authorization: "Token " + localStorage.getItem("token")
        },
    });
    const result = await res.json();
    return result;
}